// extracted by mini-css-extract-plugin
export default {"labeled-row":"Labeled-row_labeled-row__pjaZI","labeled-row__label":"Labeled-row_labeled-row__label__IQYKX"};